module.exports = __webpack_public_path__ + "public-ui/img/realist.f058597a.svg";